export default "__VITE_ASSET__PypTDhDF__"